import $ from "jquery";

var level = 1;

var $menu = $("#menu-mobile");

$("#menu-mobile a").on("click", function(e) {
  var $href = $(this).attr("href");
  var $next = $(this).next();
  if ($href == "#") {
    e.preventDefault();
    $next.click();
  }
});

function isLevelOne() {
  var $drillUp = $menu.prev();
  if (level === 1) {
    $drillUp.removeClass("active");
  } else {
    $drillUp.addClass("active");
  }
}

function drillDown() {
  level++;
  isLevelOne();
}

function drillUp() {
  level--;
  isLevelOne();
}

// Set level 1 as active
$menu.addClass("active");
// Add up button
$menu.before("<span class='drill-up'>Back</span>");
// Add down buttons
$menu.find("li").each(function() {
  var $li = $(this);
  if ($li.hasClass("menu-item-has-children")) {
    var $a = $li.children("a");
    $a.after("<span class='drill-down'>+</span>");
  }
});
// down on click
$(".drill-down").on("click", function() {
  var $this = $(this);
  var $parentUl = $this.closest("ul");

  $this.next().addClass("active");
  $parentUl.removeClass("active");

  drillDown();
});
// up on click
$(".drill-up").on("click", function(e) {
  var $activeUl = $menu.find("ul.active");
  var $activeUlParent = $activeUl.parents("ul").first();

  $activeUl.removeClass("active");
  $activeUlParent.addClass("active");

  drillUp();
});

isLevelOne();

$(".navbar__trigger .trigger").on("click", function() {
  var $this = $(this);
  var navbarMenu = $(".navbar__menu");

  navbarMenu.toggleClass("active");
  $this.toggleClass("active");
});
